import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from 'store'
import { shiftToast, ToastState } from 'store/toast'
import { ToastPortal } from './ToastPortal'
import { Toast } from './Toast'

interface ToastContainerProps {
	toast: ToastState
}

class ToastContainer extends React.Component<ToastContainerProps> {
	render(): React.ReactNode {
		const toastOutput = this.props.toast.toasts.map((toast, index) => {
			return <Toast key={index} toast={toast} />
		})

		return (
			<ToastPortal>
				<div style={{ position: 'fixed', width: 'auto', height: 'auto', top: '10px', right: '10px', zIndex: 1000 }}>{toastOutput}</div>
			</ToastPortal>
		)
	}
}

const mapStateToProps = (state: ApplicationState): { toast: ToastState } => ({
	toast: state.toast
})

export default connect(mapStateToProps, { shiftToast })(ToastContainer)
